export default __webpack_public_path__ + "img/teaming-logo.2129c884.svg";